import { render, staticRenderFns } from "./navigation-on-page.vue?vue&type=template&id=6142a925&"
import script from "./navigation-on-page.vue?vue&type=script&lang=js&"
export * from "./navigation-on-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports